var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "data-table-wrapper", class: [_vm.datasetName] },
    [
      _vm._t("filter", function () {
        return [
          !_vm.hideFilter
            ? _c(
                "div",
                { staticClass: "table-filter-expression-wrapper" },
                [
                  _vm.filterColumns.length > 0
                    ? _c("filter-expression", {
                        staticClass: "header-filter-expression",
                        attrs: {
                          columns: _vm.filterColumns,
                          "dataset-name": _vm.datasetName,
                          "filter-groups": _vm.filterGroups,
                          operator: _vm.operator,
                        },
                        on: {
                          "filters-updated": _vm.updateFilterGroups,
                          "operator-changed": _vm.updateOperator,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _c("vy-table", {
        attrs: {
          columns: _vm.columns,
          categories: _vm.categories,
          sources: _vm.sources,
          "data-index": _vm.dataIndex,
          "table-data": _vm.localTableData,
          filter: _vm.filter,
          "persistence-I-D": _vm.persistenceId,
          "auto-fetch-config": _vm.autoFetchConfig,
          "reload-data": _vm.reloadData,
          "set-first-page": _vm.setFirstPage,
          "shown-columns": _vm.shownColumns,
          "show-edit": !_vm.hideEdit,
          "disable-row-selection": _vm.disableRowSelection,
          "nested-field-separator": _vm.nestedFieldSeparator,
        },
        on: {
          "data-loaded": _vm.handleDataLoaded,
          "data-changed": _vm.handleDataChanged,
          "data-filtered": _vm.handleDataFiltered,
          "column-selection": _vm.handleColumnSelectionChange,
          "table-sorted": _vm.handleSortChange,
          "row-click": _vm.handleRowClick,
          "row-expanded": _vm.handleRowExpanded,
          "table-persistence-updated": _vm.handlePersistenceUpdated,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }